const PUBLIC_SLUGS: Record<string, string> = { fragancias: "perfumes" }
const CATALOG_HANDLES: Record<string, string> = Object.fromEntries(Object.entries(PUBLIC_SLUGS).map(([handle, slug]) => [slug, handle]))

const RENAMED_HANDLES: Record<string, string> = {
  "accesorios-de-lactancia": "lactancia",
  "accesorios-gamer": "accesorios-para-videojuegos",
  "accesorios-hombre": "accesorios",
  "aduifonos-audio": "reproductores-de-audio-y-video-portatiles",
  "alimentacion-y-lactancia": "alimentacion-del-bebe",
  "almacenamiento-de-ropa-y-zapatos": "almacenamiento-para-ropa",
  "audifonos-gamer": "reproductores-de-audio-y-video-portatiles",
  audio: "sistemas-de-audio-y-video-para-el-hogar",
  "bano-e-higiene-del-bebe": "productos-de-higiene-para-bebes",
  "belleza-y-cuidado-personal": "salud-y-belleza",
  "biberones-y-chupones": "accesorios-para-biberones",
  bocinas: "sistemas-de-audio-y-video-para-el-hogar",
  "bolsas-de-viaje": "viajes-y-equipaje",
  "botas-hombres": "botas-hombre",
  "botas-mujeres": "botas-mujer",
  "botas-niñas": "calzado-para-ninos",
  "botas-niños": "calzado-para-ninos",
  "calzado-general": "zapatos-y-calzado",
  "calzado-hombres": "calzado-para-hombre",
  "calzado-mujeres": "calzado-de-mujer",
  "calzado-ninas": "calzado-para-ninos",
  "calzado-ninos": "calzado-para-ninos",
  "camaras-de-seguridad-y-alarmas": "automatizacion-y-seguridad-en-el-hogar",
  cargadores: "cables-cargadores-y-adaptadores",
  "carriolas-y-cochecitos": "cochecitos-y-accesorios",
  "celulares-celulares-y-telefonia": "celulares",
  "celulares-y-telefonia": "celulares",
  "cocina-hogar": "cocina-y-comedor",
  "coleccionables-jugetes": "juguetes",
  "consolas-y-controles": "consolas-de-videojuegos",
  "cuarto-del-bebe": "cuarto-de-bebe",
  "cuidado-de-la-barba": "afeitado-y-depilacion",
  "cuidado-del-cabello": "cuidado-y-peinado-del-cabello",
  "cuidado-masculino": "afeitado-y-depilacion",
  "electronica-audio-y-video": "electronica",
  "equipo-de-sonido-y-amplificadores": "sistemas-de-audio-y-video-para-el-hogar",
  "esterilizadores-y-accesorios": "esterilizadores-y-articulos-de-limpieza-de-biberones",
  "farmacia-y-primeros-auxilios": "primeros-auxilios",
  fotografia: "camaras",
  "fundas-y-accesorios": "accesorios-para-relojes-inteligentes-y-celulares",
  gaming: "videojuegos",
  gastronomia: "comida-y-bebida",
  "herramientas-y-accesorios": "herramientas",
  "higiene-personal": "cuidado-y-peinado-del-cabello",
  "hobbies-y-coleccionables": "antiguedades-y-articulos-de-coleccion",
  "hogar-cocina-y-jardin": "casa",
  iluminacion: "lamparas-e-iluminacion",
  "instrumentos-musicales-otros": "instrumentos-musicales",
  "laptops-y-computadoras": "computadoras-portatiles",
  "limpieza-x": "productos-de-limpieza",
  mama: "ropa-de-maternidad",
  "medicina-especializada": "salud",
  "mobiliario-para-oficina": "muebles-de-oficina",
  "mochilas-mochilas-y-bolsas": "mochilas",
  "mochilas-y-bolsas": "mochilas",
  "moda-x": "ropa-y-accesorios",
  "mouses-gamer": "perifericos-de-computadora",
  ninos: "ropa-para-ninos",
  "nintendo-consolas-y-controles": "consolas-de-videojuegos",
  "nintendo-jugetes": "videojuegos",
  "oficina-y-negocios": "suministros-de-oficina",
  organizacion: "organizacion-y-almacenamiento",
  "perfumes-hombre": "fragancias-para-hombre",
  "perfumes-mujer": "fragancias-para-mujer",
  "play-station-consolas-y-controles": "consolas-de-videojuegos",
  "playstation-fundas-accesorios": "accesorios-para-videojuegos",
  "playstation-jugetes": "videojuegos",
  "rehabilitacion-y-movilidad": "salud",
  "relojes-hombre": "relojes-de-pulsera",
  "ropa-all": "ropa",
  "salud-y-hogar": "salud",
  "sandalias-hombres": "sandalias-hombre",
  "sandalias-mujeres": "sandalias-mujer",
  "sandalias-niñas": "calzado-para-ninos",
  "sandalias-niños": "calzado-para-ninos",
  "seguridad-y-proteccion": "automatizacion-y-seguridad-en-el-hogar",
  "suministros-para-oficina": "suministros-de-oficina",
  "teclados-gamer": "perifericos-de-computadora",
  "teclados-y-accesorios": "perifericos-de-computadora",
  "tenis-hombres": "calzado-deportivo-hombre",
  "tenis-mujeres": "calzado-deportivo-mujer",
  "tenis-niñas": "calzado-para-ninos",
  "tenis-niños": "calzado-para-ninos",
  "videojuegos-jugetes": "videojuegos",
  "xbox-consolas-y-controles": "consolas-de-videojuegos",
  "xbox-jugetes": "videojuegos",
  "zapatos-bebes": "calzado-para-bebes",
  "zapatos-hombres": "calzado-para-hombre",
  "zapatos-mujeres": "calzado-de-mujer",
  "zapatos-niñas": "calzado-para-ninos",
  "zapatos-niños": "calzado-para-ninos",
}

export const publicCategorySlug = (handle: string): string => {
  const catalogHandle = Object.hasOwn(RENAMED_HANDLES, handle) ? RENAMED_HANDLES[handle]! : handle
  return Object.hasOwn(PUBLIC_SLUGS, catalogHandle) ? PUBLIC_SLUGS[catalogHandle]! : catalogHandle
}

export const catalogCategoryHandle = (slug: string): string => (Object.hasOwn(CATALOG_HANDLES, slug) ? CATALOG_HANDLES[slug]! : slug)

const folded = (segment: string): string => segment.normalize("NFC").toLowerCase()

export const resolveCategorySlug = (slug: string): string => catalogCategoryHandle(publicCategorySlug(folded(slug)))

export const legacyCategoryPath = (segments: string[]): string => {
  const last = segments.at(-1)
  return last ? `/categorias/${encodeURIComponent(publicCategorySlug(folded(last)))}` : "/categorias"
}
